import { render, staticRenderFns } from "./mobile-header-foot.vue?vue&type=template&id=3774a3bc&scoped=true"
import script from "./mobile-header-foot.vue?vue&type=script&lang=js"
export * from "./mobile-header-foot.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-foot.vue?vue&type=style&index=0&id=3774a3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774a3bc",
  null
  
)

export default component.exports